import React from "react";
import { getClassNames } from "../../../utils";

function CellWithMessageTitleClient({
    isRead = false,
    title = null,
    subtitle = null,
}) {
    const className = getClassNames(
        "table-cell_with-subtext",
        "table-cell_with_message",
        { "table-cell_with_message-new": !isRead }
    );

    return (
        <div className={className}>
            <b>{title}</b>
            <p data-isread={isRead}>{subtitle}</p>
        </div>
    );
}


export default CellWithMessageTitleClient;
